import type { IFrameComponent } from 'iframe-resizer';
import iFrameResize from 'iframe-resizer/js/iframeResizer.min';

export const reopenKey = 'TTGRAF__cancel_reopen';

export enum ShowWindow {
    BUTTON_CLICK = 'BUTTON_CLICK',
    TIME_INTERVAL = 'TIME_INTERVAL',
}

export enum EmbedShow {
    LOAD_READY = 'LOAD_READY',
    CLICK_LINK = 'CLICK_LINK',
}

export const iOS =
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent,
);

export const nop = (): void => void 0;

// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);

export const resize = (iframe: HTMLIFrameElement, cb: (e?: AnyObject) => void, maxHeight?: number): void => {
    iFrameResize(
        {
            log: false,
            enablePublicMethods: true,
            maxHeight,
            tolerance: 3,
            autoResize: true,
            checkOrigin: false,
            heightCalculationMethod: 'bodyScroll',
            onResized: cb || nop,
        },
        iframe,
    );
};

export const request = (path: string, data: AnyObject, callback: (xhr: XMLHttpRequest) => void): void => {
    // TODO use fetch
    const xhr = new XMLHttpRequest();
    xhr.open('POST', path, true);

    const formData = new FormData();
    for (const [key, val] of Object.entries(data)) {
        formData.append(key, val as string);
    }

    xhr.send(formData);

    xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) return;
        if (xhr.status !== 200) {
            console.error(xhr.status + ': ' + xhr.statusText);
        } else {
            callback(xhr);
        }
    };
};

export const mergeQueryString = (params: AnyObject = {}): string => {
    let search: any = new URLSearchParams();

    for (const [k, v] of Object.entries({ ...params, ...(window?.testograf?.params || {}) })) {
        search.append(k, v);
    }

    search = search.toString();

    return search ? `?${search}` : '';
};

const prefix = 'tte';
export const createIFrameId = (id: number): string => `${prefix}-i-${id}`;
export const createTriggerId = (id: number): string => `${prefix}-tr-${id}`;
export const createPopupTriggerId = (id: number): string => `${prefix}-p-tr--${id}`;
export const createPopupId = (id: number): string => `${prefix}-reop-${id}`;

export const div = (): HTMLDivElement => document.createElement('div');

export const frame = (id: number): IFrameComponent => {
    const f = document.createElement('iframe') as IFrameComponent;

    f.setAttribute('id', `ttgraf-${id}`);
    f.setAttribute('loading', 'lazy');
    f.setAttribute(
        'sandbox',
        'allow-same-origin allow-scripts allow-forms allow-popups' + (iOS ? '' : ' allow-downloads'),
    );

    f.style.border = 'none';
    f.style.width = '100%';
    f.style.minWidth = '100%';

    return f;
};

export const onLoad = (fn: () => void): void => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        fn();
    }
};

const referer = window.location.href;

// `http://${rewrite}.localhost:8088/${mergeQueryString({ embedded, source, referer })}`;
export const createSurveyUrl = (rewrite: string, source: string, embedded = false): string =>
    `${HOST_PROTOCOL_ENV}${rewrite}.${HOST_DOMAIN_ENV}/${mergeQueryString({ embedded, source, referer })}`;

export const popupPrefix = 'ttp-';
